module.exports = __webpack_public_path__ + "static/14-5ce3fd89c3bd3393ce36a9e8c9edff03.png";